export const contentStyle = {
  padding: 0,
};
